<script>
const pdfjsLib = window['pdfjs-dist/build/pdf'];
pdfjsLib.GlobalWorkerOptions.workerSrc =
  '//unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js';
import { PDFDocument, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';

export default {
  data() {
    return {
      pdf: null,
      page: 1,
      pagesCount: 1,
      signed: {},
      signedPdf: null,
      signedPdfList: [],
      placing: null,
      replacingTextWithElement: null,
      textWidths: {},
      renderTask: null,
      errorMessage: null,
      fonts: null,
      zoom: 1
    };
  },
  watch: {
    file(newValue) {
      if (newValue == null) {
        this.page = 1;
        this.elements = [];
      }
      if (this.signedPdf == null) this.renderPdf();
    },
    page() {
      this.renderPage();
    },
    placing() {
      this.renderPage();
    },
    replacingTextWithElement() {
      this.renderPage();
    },
    signedPdf() {
      this.renderPdf();
    },
  },
  methods: {
    clearBox(canvas, x, y, width, height) {
      const canvasContext = canvas.getContext('2d');
      canvasContext.fillStyle = 'white';
      canvasContext.fillRect(
        x * canvas.width,
        y * canvas.height,
        width * canvas.width,
        height * canvas.height
      );
    },
    getBoxWidth(label, fontSize, canvas) {
      const canvasContext = canvas.getContext('2d');
      canvasContext.font = fontSize + 'px arial';
      return canvasContext.measureText(label).width;
    },
    renderBox(idx, canvas, x, y) {
      if(idx === null) return;
      const canvasContext = canvas.getContext('2d');
      let element = {fontId: 1, fontSize: 20, color: 'lightyellow'};
      if(this.elements && this.elements.length !== 0)
      {
        element = this.elements[idx];
      }
      const elementFont = this.fonts !== null && element !== null ? this.fonts.find((f) => f.id === element.fontId) : null;
      canvasContext.font = `${element.fontSize}px ${
        elementFont != null ? elementFont.name : 'arial'
      }`;
      canvasContext.fillStyle = element.color ? element.color : 'lightyellow';
      canvasContext.beginPath();

      this.textWidths[idx] = canvasContext.measureText(element.label).width;
      const lineHeight = element.fontSize * 1.286;

      canvasContext.rect(
        x * canvas.width / (this.zoom >= 1 ? 1 : this.zoom),
        y * canvas.height / (this.zoom >= 1 ? 1 : this.zoom),
        this.textWidths[idx] + 6,
        lineHeight + 6
      );
      canvasContext.fill();
      canvasContext.stroke();

      canvasContext.fillStyle = 'black';
      canvasContext.fillText(
        element.label,
        x * canvas.width / (this.zoom >= 1 ? 1 : this.zoom) + 3,
        y * canvas.height / (this.zoom >= 1 ? 1 : this.zoom) + lineHeight / 1.286
      );
    },
    async renderPdf() {
      await this.$nextTick();

      const canvas = this.$refs.canvas;
      const canvasContext = canvas.getContext('2d');

      canvasContext.clearRect(0, 0, canvas.width, canvas.height);
      if (this.file == null) {
        return;
      }
      try {
        const data =
          this.signedPdf != null ? this.signedPdf : await this.getPdfData();
        const loadingTask = pdfjsLib.getDocument({ data });
        this.pdf = await loadingTask.promise;
        this.pagesCount = this.pdf.numPages;

        await this.renderPage();
      } catch (error) {
        this.errorMessage = error;
      }
    },
    async renderPage() {
      if (this.renderTask != null) this.renderTask.cancel();

      const canvas = this.$refs.canvas;
      const overlay = this.$refs.overlay;
      const canvasContext = canvas.getContext('2d');
      await canvasContext.clearRect(0, 0, canvas.width, canvas.height);

      const page = await this.pdf.getPage(this.page);

      const viewport = page.getViewport({ scale: 2 });

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const canvasWidth = 100 * this.zoom
      canvas.style.width = `${canvasWidth}%`;
      if(overlay)
      {
        overlay.width = canvas.width;
        overlay.height = canvas.height;
        overlay.style.width = `${canvasWidth}%`
      }
      

      const renderContext = {
        canvasContext,
        viewport,
      };
      try {
        this.renderTask = page.render(renderContext);
        await this.renderTask.promise;
      } catch (error) {
        this.errorMessage = error;
      }

      this.elements.forEach((element, i) => {
        element.placements.forEach((p, pi) => {
          if (
            p.text != null &&
            p.text.page === this.page &&
            !(this.signed[i] && pi in this.signed[i])
          ) {
            this.clearBox(
              canvas,
              p.text.left,
              p.text.top,
              p.text.width,
              p.text.height
            );
            if(this.zoom >= 1)
            {
              this.renderBox(i, canvas, p.text.left, p.text.top);
            }
            else
            {
              this.renderBox(i, canvas, p.text.left* this.zoom, p.text.top* this.zoom);
            }
          } else if (p.page === this.page) {
            if (!(this.signed[i] && pi in this.signed[i])) {
              if(this.zoom >= 1)
              {
                this.renderBox(i, canvas, p.xPosition, p.yPosition);
              }
              else
              {
                this.renderBox(i, canvas, p.xPosition * this.zoom, p.yPosition * this.zoom);
              }
            }
          }
        });
      });
    },
    parsePdfInfo(acc, page, idx) {
      const pageElements = page.text.map((t) => ({
        text: t.data,
        value: {
          ...t,
          page: idx + 1,
          top: t.top / page.height,
          left: t.left / page.width,
          width: t.width / page.width,
          height: t.height / page.height,
        },
      }));
      return [...acc, ...pageElements];
    },
    async loadPdfDocument(pdfFile = null) {
      var document = {};
      document.pdfDoc =
        pdfFile == null
          ? await PDFDocument.load(this.getPdfData())
          : await PDFDocument.load(pdfFile);
      document.pdfDoc.registerFontkit(fontkit);
      document.dateFont = await document.pdfDoc.embedFont(
        StandardFonts.Helvetica
      );
      document.pages = document.pdfDoc.getPages();

      return document;
    },
    async renderPdfList(pdfList) {
      var convertedPdfList = pdfList;
      for (var pdf of convertedPdfList) {
        var document = await PDFDocument.load(pdf.fileContent.fileContents);
        const convertedDocument = await document.save();
        var blob = new Blob([convertedDocument], { type: 'application/pdf' });

        pdf.convertedPdf = blob;
      }
      return convertedPdfList;
    },
    async getFont(fontId, pdfDoc) {
      var fonts = null;
      if (fontId === 1) {
        fonts = await pdfDoc.embedFont(StandardFonts.Helvetica);
      } else if (fontId === 2) {
        const fontUrl = '/Calibri.ttf';
        const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
        fonts = await pdfDoc.embedFont(fontBytes);
      } else if (fontId === 3) {
        fonts = await pdfDoc.embedFont(StandardFonts.TimesRoman);
      } else if (fontId === 4) {
        const fontUrl2 = '/arial.ttf';
        const fontBytes2 = await fetch(fontUrl2).then((res) =>
          res.arrayBuffer()
        );
        fonts = await pdfDoc.embedFont(fontBytes2);
      } else {
        fonts = await pdfDoc.embedFont(StandardFonts.Helvetica);
      }
      return fonts;
    },

    setZoom(incomingZoom)
    {
      if((Math.round(incomingZoom * 100) / 100) >= 0.4)
      {
        this.zoom = incomingZoom
        this.renderPage()
      }
    }
  },
};
</script>
